import {
  ComponentIds,
  Entity,
  GuestConnectionsComponent,
  HierarchyUtils
} from '@inter-ikea-core/core';
import { CoreApi } from '@inter-ikea-storageone/range';

export const getInteriorsInLoftBedCabinet = (loftBed: Entity) => {
  return HierarchyUtils.children(loftBed).filter(child => {
    const hostConnector = child.getComponent<GuestConnectionsComponent>(
      ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID
    )?.highestPriorityConnection?.hostConnector;
    return (
      (hostConnector?.key.includes('cabinet-left-hole-series') ||
        hostConnector?.key.includes('cabinet-right-hole-series')) &&
      hostConnector?.key !== 'cabinet-left-hole-series-2'
    );
  });
};

export const getInteriorsInLoftBedDesk = (loftBed: Entity) => {
  return HierarchyUtils.children(loftBed).filter(child =>
    child
      .getComponent<GuestConnectionsComponent>(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
      ?.highestPriorityConnection?.hostConnector.key.includes('desk-left-hole-series')
  );
};

export const shouldDisableLoftBedProducts = (coreApi: CoreApi) => {
  const ceilingHeight = coreApi.kvadratRoom?.getSize().Y;
  return (ceilingHeight && ceilingHeight < 2400) || false;
};
